import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sm-cancel-booking-notes-modal',
  templateUrl: './cancel-booking-notes-modal.component.html',
  styleUrls: ['./cancel-booking-notes-modal.component.scss']
})
export class CancelBookingNotesModalComponent implements OnInit {
  notes:any = ''
  constructor(@Inject(MAT_DIALOG_DATA) public parentdata:any, private activemodal: MatDialogRef<CancelBookingNotesModalComponent>) { }

  ngOnInit(): void {
  }

  onPost(){
   this.activemodal.close({
    notes: this.notes
   })
  }
}
